import React from 'react';
import { Target } from 'lucide-react';
import DailyQuest from '../../components/DailyQuest';

export const meta = {
  id: 'daily_quest',
  category: 'personal',
  titleKey: 'dashboard.widgets.dailyQuest',
  descriptionKey: 'dashboard.widgets.dailyQuestDesc',
  defaultSize: 'xl',
  icon: Target,
};

// Thin registry wrapper around the existing DailyQuest component so it can be
// moved/resized/removed like any other widget. The component self-gates by
// role and renders null when there's no active quest.
export default function DailyQuestWidget() {
  return <DailyQuest />;
}
